var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoProyecto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1945",
    "data-name": "Group 1945",
    xmlns: "http://www.w3.org/2000/svg",
    width: 333.906,
    height: 51.691,
    viewBox: "0 0 333.906 51.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1941",
    "data-name": "Group 1941",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M1342.919,700.307h-5.263v6.141h5.336a2.682,2.682,0,0,0,2.741-2.961C1345.734,701.879,1344.82,700.307,1342.919,700.307Z",
    transform: "translate(-1225.969 -681.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M1470.121,699.87c-4.13,0-6.981,3-6.981,7.237,0,4.277,2.888,7.237,6.981,7.237,4.24,0,6.981-3,6.981-7.237C1477.1,702.721,1474.361,699.87,1470.121,699.87Z",
    transform: "translate(-1288.475 -681.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M1160.332,700.817h-3.8v13.451h3.8c4.606,0,6.214-3.436,6.214-6.945S1164.755,700.817,1160.332,700.817Z",
    transform: "translate(-1135.747 -681.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M1115.119,662.84v51.69h209.31V662.84Zm24.585,38.615H1128.74V675.869H1139.7c9.029,0,13.378,5.555,13.378,12.61S1148.879,701.455,1139.7,701.455Zm25.148,0h-7.2V675.869h7.2Zm15.607.731c-4.6.037-7.895-.767-11.44-4.5l3.984-4.569a10.264,10.264,0,0,0,7.493,2.888c2.375,0,4.021-.841,4.021-2.266,0-1.279-1.463-2.083-4.276-2.339-5.592-.511-10.417-1.937-10.417-8.3,0-5.409,5.3-7.748,10.709-7.748a14.527,14.527,0,0,1,9.576,3.034l-3.582,4.569a9.573,9.573,0,0,0-5.995-1.754c-1.755,0-3.472.548-3.472,1.9,0,1.755,1.717,2.011,4.24,2.267,5.08.548,10.38,2.6,10.38,8.48C1191.68,699.663,1186.2,702.149,1180.459,702.185Zm35.235-20.359H1208.2v19.628H1201V681.827h-7.456v-5.957h22.149Zm27.559,19.628h-7.968l-5.958-8.3h-2.522v8.3h-7.236V675.869h12.5c6.543,0,9.942,4.2,9.942,8.808,0,3.143-1.1,5.812-5.41,7.712l6.652,8.626Zm11.186,0h-7.2V675.869h7.2Zm26.024-19.628h-7.493v19.628h-7.2V681.827h-7.456v-5.957h22.15Zm16.3,20.249c-8.37,0-14.218-4.861-14.218-13.414,0-8.406,5.849-13.414,14.218-13.414,8.406,0,14.218,4.9,14.218,13.414C1310.983,697.215,1305.171,702.076,1296.765,702.076Z",
    transform: "translate(-1115.119 -662.84)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1943",
    "data-name": "Group 1943",
    transform: "translate(223.819 11.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1942",
    "data-name": "Group 1942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M1565.175,702.85v7.859h-4.094V685.123c3.911,0,7.932-.036,11.842-.036,12.208,0,12.245,17.69,0,17.763Zm0-3.764h7.748c6.762,0,6.725-10.235,0-10.235h-7.748Z",
    transform: "translate(-1561.081 -685.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M1615.608,685.232v25.549h-3.765V685.232Z",
    transform: "translate(-1586.367 -685.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M1644.673,699.835h3.655v18.019h-3.582l-.183-2.924a7.125,7.125,0,0,1-6.213,3.4c-5.263.037-9.247-3.363-9.247-9.5,0-6.031,4.13-9.394,9.32-9.394a6.96,6.96,0,0,1,6.14,3.253Zm-11.806,8.992a5.681,5.681,0,0,0,5.849,5.995c7.785,0,7.785-11.952,0-11.952A5.67,5.67,0,0,0,1632.867,708.827Z",
    transform: "translate(-1594.964 -692.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M1690.99,700.234v1.755l-9.064,12.574h9.138v3.691H1676.15v-1.535l9.321-13.049h-8.7v-3.436Z",
    transform: "translate(-1618.399 -692.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M1728.135,699.835h3.655v18.019h-3.582l-.183-2.924a7.125,7.125,0,0,1-6.214,3.4c-5.263.037-9.247-3.363-9.247-9.5,0-6.031,4.13-9.394,9.321-9.394a6.958,6.958,0,0,1,6.14,3.253Zm-11.806,8.992a5.681,5.681,0,0,0,5.848,5.995c7.785,0,7.785-11.952,0-11.952A5.67,5.67,0,0,0,1716.329,708.827Z",
    transform: "translate(-1636.538 -692.233)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1944",
    "data-name": "Group 1944",
    transform: "translate(209.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M1656.769,662.84H1532.175v.8h123.791v50.085H1532.175v.8h124.594Z",
    transform: "translate(-1532.175 -662.84)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/logo-proyecto.5dac39a02b06a55446ee498b80f8bc92.svg";
export { ForwardRef as ReactComponent };